import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";
import formatDate from "../utils/formatDate";

export const getJurnal = createAsyncThunk("jurnal/getJurnal", async ({ start_time, end_time, search }, { rejectWithValue }) => {
    try {
        const response = await axios.get(
            getBaseUrl + '/api/jurnal-guru',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    start_time,
                    end_time,
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

export const getJurnalTerbaru = createAsyncThunk("jurnal/getJurnalTerbaru", async ({ start_time }, { rejectWithValue }) => {
    try {
        const response = await axios.get(
            getBaseUrl + '/api/jurnal-guru',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    start_time,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

const jurnalSlice = createSlice({
    name: 'jurnal',
    initialState: {
        listTabbar: [
            { kategori: 'Belum Divalidasi', id: 1 },
            { kategori: 'Valid', id: 2 },
            { kategori: 'Tidak Valid', id: 3 },
        ],
        jurnalBelumDivalidasi: [],
        jurnalTidakValid: [],
        jurnalValid: [],

        currentKategori: null,

        jurnalTerbaru: [],
        search: '',
        startTime: formatDate(new Date()),
        endTime: null,
        startText: 'Tanggal mulai',
        endText: 'Tanggal berakhir',
        currentPage: 1,
        keterangan: 'Belum Divalidasi',
        urutan: 'Mengajar',
        loading: false,
        loadingJurnalTerbaru: false,
        kategoriId: null,
        isPaginationClicked: false,



        statusResApi: '',
        messageResApi: '',
        isDisplayMessage: false,
    },
    reducers: {
        updateStateJurnal: (state, action) => {
            const { name, value } = action.payload
            state[name] = value
        },
        setKategoriId: (state, action) => {
            state.kategoriId = action.payload
        },
        setCurrentKategori: (state, action) => {
            state.currentKategori = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJurnal.pending, (state) => {
                state.loading = true;
            })
            .addCase(getJurnal.fulfilled, (state, action) => {
                state.loading = false;


                state.jurnalBelumDivalidasi = action.payload.data.belum_divalidasi
                state.jurnalTidakValid = action.payload.data.tidak_valid
                state.jurnalValid = action.payload.data.valid

                console.log();
            })
            .addCase(getJurnal.rejected, (state, action) => {
                state.loading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })


            .addCase(getJurnalTerbaru.pending, (state) => {
                state.loadingJurnalTerbaru = true;
            })
            .addCase(getJurnalTerbaru.fulfilled, (state, action) => {
                state.loadingJurnalTerbaru = false;
                let jurnalMasuk = action.payload.data.masuk;
                let jurnalKeluar = action.payload.data.pulang;

                state.jurnalTerbaru = [...jurnalMasuk, ...jurnalKeluar];
            })
            .addCase(getJurnalTerbaru.rejected, (state, action) => {
                state.loadingJurnalTerbaru = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            });
    }
})

export const {
    updateStateJurnal,setKategoriId,setCurrentKategori
} = jurnalSlice.actions
export default jurnalSlice.reducer;